/** @format */
import { addProductToSet, removeProductFromSet } from './bundles.actions';
import { createReducer, on } from '@ngrx/store';
import { BundlesState } from '@pdp/data-access/interfaces';

export const initialBundleState: BundlesState = {
	selectedSkus: []
};

export const bundlesReducers = createReducer(
	initialBundleState,
	on(addProductToSet, (state, { sku }) => {
		const updatedSelectedSkus = [...state.selectedSkus];
		updatedSelectedSkus.push(sku);
		return {
			...state,
			selectedSkus: updatedSelectedSkus
		};
	}),
	on(removeProductFromSet, (state, { skuId }) => {
		let updatedSelectedSkus = [...state.selectedSkus];
		updatedSelectedSkus = updatedSelectedSkus.filter((product) => product.sku.partNumber !== skuId);
		return {
			...state,
			selectedSkus: updatedSelectedSkus
		};
	})
);

export const bundlesReducer = (state, action) => bundlesReducers(state, action);
